export default __webpack_public_path__ + "static/media/Inter-ExtraLight.21843ac6.woff2";